module.exports = __webpack_public_path__ + "static/bo-ba3aba41dd289ec8edd6ed37451fcc51.svg";